// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 财达开户客户详情 POST /broker-open/cd-customer-info */
export async function brokerOpenCdCustomerInfoUsingPOST(options?: { [key: string]: any }) {
  return request<API.BaseResultBrokerOpenCdCustomerListResp>('/broker-open/cd-customer-info', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取券商开户邀请码 GET /broker-open/invite-code */
export async function brokerOpenInviteCodeUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.brokerOpenInviteCodeUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/broker-open/invite-code', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
